var map = {
	"./modulo_07.svg": 686,
	"./modulo_Avatar.svg": 687,
	"./modulo_Benefit.svg": 437,
	"./modulo_Boton.svg": 688,
	"./modulo_Flags.svg": 689,
	"./modulo_Gallery.svg": 690,
	"./modulo_HTML.svg": 691,
	"./modulo_Icon.svg": 692,
	"./modulo_Icons.svg": 693,
	"./modulo_Imagen.svg": 694,
	"./modulo_Lead.svg": 695,
	"./modulo_Leads.svg": 696,
	"./modulo_Line.svg": 697,
	"./modulo_Name.svg": 698,
	"./modulo_Parrafo.svg": 699,
	"./modulo_Parrafo_new.svg": 700,
	"./modulo_QRCode.svg": 701,
	"./modulo_Review.svg": 702,
	"./modulo_Reward.svg": 438,
	"./modulo_SaveDate.svg": 703,
	"./modulo_Social.svg": 704,
	"./modulo_Space.svg": 705,
	"./modulo_Star.svg": 706,
	"./modulo_Titulo.svg": 547,
	"./modulo_Ubicacion.svg": 707,
	"./modulo_VCF.svg": 708,
	"./modulo_Video.svg": 709,
	"./modulo_Whereby.svg": 710,
	"./modulo_Xai.svg": 711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;